var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotaline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 194,
    viewBox: "0 0 8 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 1.51758C4.75 1.10336 4.41421 0.767578 4 0.767578C3.58579 0.767578 3.25 1.10336 3.25 1.51758L4.75 1.51758ZM8.21774e-06 189.518C8.31431e-06 191.727 1.79087 193.518 4.00001 193.518C6.20915 193.518 8.00001 191.727 8.00001 189.518C8.00001 187.308 6.20915 185.518 4.00001 185.518C1.79087 185.518 8.12118e-06 187.308 8.21774e-06 189.518ZM3.25 1.51758L3.25001 189.518L4.75001 189.518L4.75 1.51758L3.25 1.51758Z",
    fill: "url(#paint0_linear_425_4917)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_425_4917",
    x1: 4.5,
    y1: 1.51758,
    x2: 4.50001,
    y2: 189.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64A4A8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64A4A8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotaline);
export default __webpack_public_path__ + "static/media/motaline.da58ab4beeb9ffc299b1488e69fc1b78.svg";
export { ForwardRef as ReactComponent };